// extracted by mini-css-extract-plugin
export default {"skillsDashboard":"SkillsDashboard_skillsDashboard__oMfnR"};